import { isSameDay } from 'date-fns';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import type { TimeInfo } from '../DateTimeInfo';

export const useFormatTime = () => {
  const { t } = useTranslation();

  return useCallback(
    ({ timeInfo }: { timeInfo: TimeInfo }) => {
      if ('dateFrom' in timeInfo && 'dateTo' in timeInfo && isSameDay(timeInfo.dateFrom, timeInfo.dateTo)) {
        return t('dateFormats.time', { date: { end: timeInfo.dateTo, start: timeInfo.dateFrom } });
      }

      if ('dateTime' in timeInfo) {
        return t('dateFormats.time', { date: timeInfo.dateTime });
      }

      return undefined;
    },
    [t],
  );
};
